export const productDetails = {
  // Hero Section
  'productDetails.hero.title': 'Comment fonctionne',
  'productDetails.hero.titleHighlight': 'subvention360',
  'productDetails.hero.titleEnd': '?',
  'productDetails.hero.subtitle': 'Une plateforme qui centralise les subventions disponibles et facilite la recherche d\'aides adaptées à votre profil',

  // Process Section
  'productDetails.process.title': 'Notre processus en 3 étapes simples',

  // Step 1
  'productDetails.step1.title': 'Créez votre profil',
  'productDetails.step1.description': 'Renseignez les informations de votre entreprise (SIRET, secteur d\'activité, localisation). Ces données nous permettent de filtrer les subventions correspondant à vos critères d\'éligibilité.',

  // Step 2
  'productDetails.step2.title': 'Découvrez les opportunités',
  'productDetails.step2.description': 'Consultez les subventions filtrées selon votre profil. Notre base de données regroupe les aides françaises et européennes, mises à jour régulièrement. Recherchez par mot-clé, région ou secteur d\'activité.',

  // Step 3
  'productDetails.step3.title': 'Accédez aux informations',
  'productDetails.step3.description': 'Consultez les informations détaillées : critères d\'éligibilité, montants, dates limites, documents requis et contacts des organismes. Accédez aux liens de candidature officiels.',

  // Features Section
  'productDetails.features.title': 'Les fonctionnalités qui font la différence',

  // Feature 1: Centralized Database
  'productDetails.feature1.title': 'Base de Données Centralisée',
  'productDetails.feature1.description': 'Nous regroupons les subventions françaises et européennes dans une seule plateforme, avec leurs critères d\'éligibilité, montants et dates limites. Les données sont structurées pour faciliter votre recherche.',
  'productDetails.feature1.point1': 'Base de données mise à jour régulièrement',
  'productDetails.feature1.point2': 'Filtrage par secteur, région, type d\'aide',
  'productDetails.feature1.point3': 'Informations détaillées pour chaque subvention (montants, deadlines, contacts)',

  // Feature 2: Advanced Search
  'productDetails.feature2.title': 'Recherche et Filtrage Avancés',
  'productDetails.feature2.description': 'Trouvez rapidement les subventions pertinentes grâce à plusieurs outils de recherche et de filtrage adaptés à vos besoins spécifiques.',
  'productDetails.feature2.point1': 'Recherche par mot-clé (secteur, projet, type d\'aide)',
  'productDetails.feature2.point2': 'Filtres par région, montant, date limite',
  'productDetails.feature2.point3': 'Tri par pertinence ou date de publication',

  // Feature 3: Detailed Information
  'productDetails.feature3.title': 'Informations Détaillées sur les Subventions',
  'productDetails.feature3.description': 'Pour chaque aide, accédez aux informations essentielles structurées pour faciliter votre compréhension et votre prise de décision.',
  'productDetails.feature3.point1': 'Critères d\'éligibilité (secteur, taille d\'entreprise, localisation)',
  'productDetails.feature3.point2': 'Montants et taux de subvention disponibles',
  'productDetails.feature3.point3': 'Dates limites de candidature et documents requis',
  'productDetails.feature3.point4': 'Contacts des organismes financeurs et lien vers la candidature officielle',

  // Feature 4: Time Savings
  'productDetails.feature4.title': 'Gain de Temps dans la Recherche',
  'productDetails.feature4.description': 'Gagnez du temps en évitant de parcourir des dizaines de sites web différents. Toutes les informations sont centralisées au même endroit.',
  'productDetails.feature4.point1': 'Un seul endroit pour toutes les subventions disponibles',
  'productDetails.feature4.point2': 'Filtrage rapide selon vos critères d\'éligibilité',
  'productDetails.feature4.point3': 'Accès direct aux informations clés sans naviguer entre multiples portails',

  // Feature 5: Multi-Source Coverage
  'productDetails.feature5.title': 'Couverture Multi-Sources',
  'productDetails.feature5.description': 'Notre base de données regroupe les subventions issues de plusieurs sources officielles, nationales et européennes.',
  'productDetails.feature5.point1': 'Subventions françaises (régions, ADEME, BPI France, etc.)',
  'productDetails.feature5.point2': 'Subventions européennes (FEDER, FSE+, Horizon Europe, etc.)',
  'productDetails.feature5.point3': 'Aides sectorielles et dispositifs spécifiques ajoutés régulièrement',

  // Feature 6: Consultant Directory
  'productDetails.feature6.title': 'Annuaire de Consultants Experts',
  'productDetails.feature6.description': 'Accédez à un réseau de consultants spécialisés en subventions pour vous accompagner dans vos démarches si vous en avez besoin.',
  'productDetails.feature6.point1': 'Consultants vérifiés et qualifiés par secteur et région',
  'productDetails.feature6.point2': 'Recherche par spécialisation et couverture géographique',
  'productDetails.feature6.point3': 'Contactez directement les experts adaptés à vos besoins',

  // Who Is It For Section
  'productDetails.audience.title': 'Pour qui est subvention360 ?',

  // Audience 1: Entrepreneurs
  'productDetails.audience1.title': 'Entrepreneurs & TPE/PME',
  'productDetails.audience1.description': 'Trouvez les aides à l\'investissement, à l\'innovation et au développement adaptées à votre secteur et votre région. Gagnez du temps en consultant une base centralisée.',

  // Audience 2: Associations
  'productDetails.audience2.title': 'Associations & ONG',
  'productDetails.audience2.description': 'Identifiez les subventions pour vos projets culturels, sociaux ou environnementaux. Accédez aux critères d\'éligibilité et contacts des financeurs en un seul endroit.',

  // Audience 3: Consultants
  'productDetails.audience3.title': 'Consultants & Accompagnateurs',
  'productDetails.audience3.description': 'Utilisez notre base de données pour conseiller vos clients sur les aides disponibles. Accédez rapidement aux informations structurées pour préparer vos recommandations.',

  // Audience 4: Local Authorities
  'productDetails.audience4.title': 'Collectivités Locales',
  'productDetails.audience4.description': 'Consultez les financements européens et nationaux pour vos projets territoriaux (transition écologique, aménagement, développement économique).',

  // Audience 5: Startups
  'productDetails.audience5.title': 'Startups & Scale-ups',
  'productDetails.audience5.description': 'Identifiez les dispositifs de financement de l\'innovation, de la R&D et du développement international disponibles pour les jeunes entreprises.',

  // Audience 6: Farmers
  'productDetails.audience6.title': 'Agriculteurs',
  'productDetails.audience6.description': 'Accédez aux aides PAC, subventions régionales et dispositifs de transition agricole dans une interface simplifiée.',

  // CTA Section
  'productDetails.cta.title': 'Commencez votre recherche de subventions',
  'productDetails.cta.subtitle': 'Créez votre profil gratuitement et découvrez les aides disponibles pour votre projet.',
  'productDetails.cta.createAccount': 'Créer mon compte',
  'productDetails.cta.learnMore': 'En savoir plus'
} as const;
